module.exports = __webpack_public_path__ + "static/img/109_TO8_1801_og.aa1430c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/109_TO8_1801_og.jpg
// module id = lj/0
// module chunks = 0